import { render } from "./NewTicketTitle.vue?vue&type=template&id=4473cbc7"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4473cbc7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4473cbc7', script)) {
    api.reload('4473cbc7', script)
  }
  
  module.hot.accept("./NewTicketTitle.vue?vue&type=template&id=4473cbc7", () => {
    api.rerender('4473cbc7', render)
  })

}

script.__file = "src/views/support/pageTitles/NewTicketTitle.vue"

export default script